import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { share, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class SvgIconService {
  private observableCache$: { [key: string]: Observable<Object> } = {};
  private cache$: { [key: string]: Object } = {};

  constructor(public http: HttpClient) {}

  public getSvg(src: string) {
    if (this.cache$[src]) {
      return of(this.cache$[src]);
    } else if (this.observableCache$[src]) {
      return this.observableCache$[src];
    } else {
      this.observableCache$[src] = this.requestSvg(src);
    }

    return this.observableCache$[src];
  }

  private requestSvg(src: string) {
    return this.http.get(src, { responseType: 'text' }).pipe(
      map((data) => this.mapSvg(src, data)),
      share(),
    );
  }

  private mapSvg(src: string, data: any) {
    this.observableCache$[src] = of();
    this.cache$[src] = new Object(data);
    return this.cache$[src];
  }
}
